module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./index.js"));
	}, "tabs");
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy&name=tabs!./src/web-components/tabs/index.js
// module id = 91
// module chunks = 8